<template>
  <v-card style="padding: 1rem">
    <h2 class="mb-4">Deposting</h2>
    <div class="p-4">
      <div style="width: fit-content; margin: 0 auto">
        <v-date-picker v-model="deposting_date" type="month" landscape />
      </div>
    </div>
    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" text @click="deposting()">Deposting</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from '@/libs/axios';
export default {
  name: 'ModalContentDeposting',
  data() {
    return {
      deposting_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).t,
    };
  },
  props: {
    onclose: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    async deposting() {
      try {
        const [year, month] = this.deposting_date.split('-');

        await axios.post('/utility/deposting', {
          month: parseInt(month),
          year: parseInt(year),
        });

        this.onclose();

        alert('Deposting successfuly !');
      } catch (error) {
        alert('Fail deposting');
      }
    },
  },
};
</script>
